export default __webpack_public_path__ + "static/media/051-cone.283a1889.svg";